
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '@view/a-pedido-cargar/controlador';
    import JQuery from 'jquery';
    import { Wait } from '@/__env/ext';
    import { Articulo } from '@/__env/lib/Articulos';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Cliente } from '@/__env/lib/Clientes';

    @Component( {
        name: "Componente",
        props: {},
        components: {


        }
    } )
    export default class Componente extends Vue
    {

        @Prop() public Controlador: ControladorInterfaz;

        public Cargando: boolean = false;

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        async mounted()
        {
            this.Iniciar();
            this.Eventos.push( Utiles.onKeyUp.subscribe( e => this.onKeyUp( e ) ) );
            //this.Eventos.push( Utiles.onKeyDown.subscribe( e => this.onKeyDown( e ) ) );
        }

        onKeyUp( e: KeyboardEvent )
        {
            if ( e.key == 'Enter' && e.altKey )
            {
                e.preventDefault();
                this.Guardar();
            }
            else if ( e.key == 'Escape' )
            {
                e.preventDefault();
                this.Controlador.Vista.BarraIzquierda.Modo = 'menu';

            }
        }

        Estado: 'ok' | 'cargando' | 'error' = 'cargando';
        public Cliente: Cliente = new Cliente();
        public HayCambios: boolean = false;


        async Iniciar()
        {
            this.Estado = 'cargando';

            await Wait( 100 );
            if ( this.Controlador.EdicionPedido.Cliente && this.Controlador.EdicionPedido.Cliente.Existe )
                this.Cliente = await Cliente.create( this.Controlador.EdicionPedido.Cliente.Id );
            else
                this.Cliente = new Cliente();

            this.Estado = 'ok';
            this.HayCambios = false;

            this.$nextTick( () =>
            {
                document.getElementById( 'primer-input' ).getElementsByTagName( 'input' )[0].focus();
            } );
        }

        async Guardar()
        {
            let noesnuevo = this.Cliente.Existe;
            this.Estado = 'cargando';
            let e = await this.Cliente.save();
            if ( e )
            {
                this.Estado = 'ok';
                this.Controlador.EdicionPedido.Cliente = this.Cliente;
                if ( noesnuevo )
                {
                    this.Cerrar();
                } else
                {
                    this.Controlador.Vista.BarraIzquierda.Modo = 'articulo';
                }

                this.$EventBus.Notificaciones.Completado( 'Guardado correctamente' );

            }
            else
            {
                this.Estado = 'ok';
                this.$EventBus.Notificaciones.Error( 'Error al guardar' );
            }
        }

        Cerrar()
        {
            this.Controlador.Vista.BarraIzquierda.Modo = 'menu';
        }

        public Refresh: boolean = false;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }



    }
